<div
  #wrapper
  class="visionboard-templates-wrapper"
>
  <merri-loading-spinner
    *ngIf="loading"
    class="spinner"
    diameter="75"
    [loading]="loading"
  ></merri-loading-spinner>
  <div
    class="workspace"
    *ngIf="!loading"
  >
    <mat-sidenav-container>
      <mat-sidenav
        class="sidenav"
        mode="side"
        opened
        [fixedInViewport]="fixedPos"
        [fixedTopGap]="navTopGap"
        *ngIf="!isSmallScreen"
        disableClose
      >
        <div class="drawer-container">
          <div
            class="controls"
            *ngIf="showControls"
          >
            <div class="upper-controls">
              <app-visionboard-customer-item-request-button
                *ngIf="showRequestButton"
                source="Request Item - VB Category Main Button"
                [venueId]="eventVenueId"
                [venueOptional]="true"
              ></app-visionboard-customer-item-request-button>
              <app-visionboard-workspace-vendor-filter-button></app-visionboard-workspace-vendor-filter-button>
            </div>

            <app-visionboard-global-search-button source="Category"></app-visionboard-global-search-button>
          </div>
          <div
            class="jump-list-button-wrapper"
            [class.active]="isActiveCategory(t)"
            *ngFor="let t of templates"
          >
            <button
              mat-flat-button
              class="jump-list-button"
              (click)="jumpToHeader(t)"
            >
              {{ t.title }}
            </button>
          </div>
        </div>
      </mat-sidenav>

      <mat-sidenav-content>
        <div class="visionboard-template-controls">
          <div
            class="small-controls-container"
            *ngIf="isSmallScreen"
          >
            <div class="small-controls">
              <div class="categories-dropdown">
                <button
                  class="categories-btn"
                  mat-stroked-button
                  [matMenuTriggerFor]="menu"
                >
                  <span class="categories-btn-text">Categories</span>
                  <mat-icon
                    svgIcon="chevron_down"
                    iconPositionEnd
                  ></mat-icon>
                </button>
              </div>
              <ng-container *ngTemplateOutlet="workspaceControls"></ng-container>
              <app-visionboard-workspace-vendor-filter-button
                class="vendor-filter-button-mobile"
              ></app-visionboard-workspace-vendor-filter-button>
              <app-visionboard-global-search-button source="Category"></app-visionboard-global-search-button>
              <app-visionboard-customer-item-request-button
                class="request-button-mobile"
                *ngIf="showRequestButton"
                source="Request Item - VB Category Main Button"
                [venueId]="eventVenueId"
                [venueOptional]="true"
              ></app-visionboard-customer-item-request-button>
            </div>
            <div class="small-secondary-controls">
              <app-visionboard-workspace-favorites-button-menu-learn-more></app-visionboard-workspace-favorites-button-menu-learn-more>
            </div>
          </div>

          <ng-container *ngIf="!isSmallScreen">
            <ng-container *ngTemplateOutlet="workspaceControls"></ng-container>
          </ng-container>
        </div>

        <div class="template-flex-container">
          <div
            class="jump-category"
            *ngFor="let t of templates"
          >
            <span
              #jumpCategory
              [id]="anchorMap[t.title]"
            ></span>
            <app-visionboard-workspace-template
              class="template"
              [template]="t"
            ></app-visionboard-workspace-template>
          </div>
        </div>
        <div
          class="error"
          *ngIf="error"
        >
          {{ error }}
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>

<mat-menu
  #menu="matMenu"
  class="visionboard-workspace-templates-container-mobile-mat-menu"
>
  <ng-template matMenuContent>
    <button
      mat-menu-item
      *ngFor="let t of templates"
      (click)="jumpToHeader(t)"
    >
      <span>{{ t.title }}</span>
    </button>
  </ng-template>
</mat-menu>

<ng-template #workspaceControls>
  <ng-content select="[workspace-controls]"></ng-content>
</ng-template>
